import styled from 'styled-components';

export const ResidentListTableContainer= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    border-radius: 10px;
    background: #FFF;
    width:100%;
    padding:29px 28px;
`;


export const ImportContactContainer= styled.div
.attrs(() => ({
  className: 'white mt-25',
}))`
    border-radius: 10px;
    background: #FFF;
    width:100%;
    padding:29px 28px;
    display:flex;
    flex-wrap:wrap;
    justify-content:space-between;
`;


export const FieldBtn  = styled.button
.attrs(() => ({
  className: 'btn-flat center btn large  w-100',
}))`
border-radius: 5px;
background: #fff !important;
// width:80% !important;
// width:178px !important;
height:46px !important;
font-size: 13px;
font-family: Plus Jakarta Sans !important;
font-style: normal;
font-weight: 600;
text-transform: capitalize !important;
color: #4F46E5;
border: 1px solid var(--primary-indigo, #4F46E5);

:hover{
color: var(--white, #FFF);
background: var(--primary-indigo, #4F46E5) !important;
}

`;
